import React from "react";
import commonFunction from "../../../../lib/utils/common";
import search_type_const from "../../../../lib/utils/enum.json";
import {invalidAlphanumeric} from "../../../../lib/utils/regex_cheat_sheet";

export default function HotelAutoComplete(props) {

  let hotelNameArry = props?.value?.split(",");
  const region = hotelNameArry?.[0]?.trim();

  // console.log(props.isSrp,'Hello world')
  
  return (
    <>
    {props.isMobile ?
    <>
    <div className={props?.styles?.hotel_search_wid_inputfield}>
      <label className={props.isMobile ? props?.styles?.hiddenOnMobile : ""}>
        {props.label}
      </label>
      <div className={props?.styles?.hotel_search_wid_inputfield_main}>
       <p className={props?.styles?.modal_heading}>Where do you want to stay?</p>
        <input
          type="text"
          autoComplete={"off"}
          id="myTextField"
          tabIndex="1"
          readOnly
          placeholder={
            !commonFunction.isValueEmpty(props.placholder)
              ? props.placholder
              : ""
          }
          className={`${props.styles?.search_widget_input_new} ${
            props.isMobile ? props?.styles?.hiddenOnMobile : ""
          }`}
          value={
            props?.isDetailPage
              ? props?.selectedHotel
              : !commonFunction.isValueEmpty(props.value) &&
                !props.expandAutoCompleteBool
              ? props.value
              : ""
          }
       
          onClick={() => {
            props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
            props.onChangeHotelName("");
            props.onClickHotelInput();
          }}
          disabled={props.disabled}
        />
        {!commonFunction.isValueEmpty(props.isError) &&
        props.isError === true ? (
          <div className={props.styles?.hotel_search_error_message}>
            <span>{props.value != "" ? "" : "Enter destination"}</span>
          </div>
        ) : null}
        {!commonFunction.isValueEmpty(props.isError) &&
        props.isError === true ? (
          <div className={props.styles?.hotel_search_error_message}>
            <span>
              {props.autoCompleteData.length == 0
                ? "Enter valid destination"
                : ""}
            </span>
          </div>
        ) : null}
      

         <div className={props.styles?.autocomp_container} tabIndex="1">
            <div
              className={`${props.styles?.autocomp_countryList} ${props.styles?.hotel_autocomplete_value}`}
              id="hotelDataArray"
            >
              <div className={props.styles?.input_search_destination}>
                <img className={props.styles?.search_img} src='images/search_input.svg'/>
                <input
                  type="text"
                  autoComplete={"off"}
                  id="myTextField"
                  tabIndex="1"
                  onFocus={props.onInputFocus}
                  autoFocus
                  onKeyDown={props.onKeyDownArrow}
                  placeholder={
                    !commonFunction.isValueEmpty(props.placholder)
                      ? props.placholder
                      : ""
                  }
                  className={props.styles?.search_widget_input_new}
                  value={
                    !commonFunction.isValueEmpty(props.value) ? props.value : ""
                  }
                  onChange={(event) => {
                    const newValue = event.target.value.replace(invalidAlphanumeric, "");
                    props.onChangeHotelName(newValue);
                  }}
                  onClick={() => {
                    props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
                    props.onChangeHotelName("");
                    props.onClickHotelInput();
                  }}
                />

               {/* {!commonFunction.isValueEmpty(props.value) &&
                <span className={props.styles?.cross_icon} onClick={()=> {props.onChangeHotelName("") ,props.onClickHotelInput();}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M8.91703 0.101715L5 4.01875L1.08297 0.101715C0.947348 -0.0339051 0.727788 -0.0339051 0.592514 0.101715L0.101715 0.592514C-0.0339051 0.728135 -0.0339051 0.947694 0.101715 1.08297L4.01875 5L0.101715 8.91703C-0.0339051 9.05265 -0.0339051 9.27221 0.101715 9.40748L0.592514 9.89828C0.728135 10.0339 0.947694 10.0339 1.08297 9.89828L5 5.98125L8.91703 9.89828C9.05265 10.0339 9.27221 10.0339 9.40748 9.89828L9.89828 9.40748C10.0339 9.27186 10.0339 9.0523 9.89828 8.91703L5.98125 5L9.89828 1.08297C10.0339 0.947348 10.0339 0.727788 9.89828 0.592514L9.40748 0.101715C9.27186 -0.0339051 9.0523 -0.0339051 8.91703 0.101715Z" fill="#666666"/>
              </svg>
              </span>} */}
              </div>

              <div
                className={`${props.styles?.hotel_autocomplete_value} ${props.styles?.hotel_autocompleteMain}`}
              >
                {/* {props.isMobile && (
                  <p className={props.styles?.suggestion_label}>Suggestions</p>
                )} */}

                {!commonFunction.isValueEmpty(props.autoCompleteData) &&
                  props.autoCompleteData.length > 0 ?
                  props.autoCompleteData.map((element) => {
                    let searchValue = props.value;
                  
                    return (
                      <>
                       <div
                        id="hotelData"
                        className={props.styles?.hotel_autocomplete_element}
                        onClick={() => {
                          props.onClickHotelName(element);
                          props.isAutoCompleteExpand(false);
                        }}
                      >
                         {search_type_const.search_type_const[element?.search_type]?.text == "City" ? (
                         <div className={props.styles?.hotel_autocomplete_icons}>
                          <img src="/images/Hotel_Location.svg" alt="location-icon" />
                        </div>
                        ) :search_type_const.search_type_const[element?.search_type]?.text == "Airport" ? (
                          <div className={props.styles?.hotel_autocomplete_icons}>
                           <img src="/images/Hotel_Plane.svg" alt="flightIcon" />

                        </div>
                          ) :search_type_const.search_type_const[element?.search_type]?.text == "Property" ? (
                            <div className={props.styles?.hotel_autocomplete_icons}>
                            <img src="/images/HotelBed.svg" alt="Bed_icon_new" />

                          </div>
                            ) :
                          (
                            <div className={props.styles?.hotel_autocomplete_icons}>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 1.5C7.85953 1.5 4.5 4.52391 4.5 8.25C4.5 14.25 12 22.5 12 22.5C12 22.5 19.5 14.25 19.5 8.25C19.5 4.52391 16.1405 1.5 12 1.5ZM12 12C11.4067 12 10.8266 11.8241 10.3333 11.4944C9.83994 11.1648 9.45542 10.6962 9.22836 10.1481C9.0013 9.59987 8.94189 8.99667 9.05764 8.41473C9.1734 7.83279 9.45912 7.29824 9.87868 6.87868C10.2982 6.45912 10.8328 6.1734 11.4147 6.05764C11.9967 5.94189 12.5999 6.0013 13.1481 6.22836C13.6962 6.45542 14.1648 6.83994 14.4944 7.33329C14.8241 7.82664 15 8.40666 15 9C14.9991 9.79538 14.6828 10.5579 14.1204 11.1204C13.5579 11.6828 12.7954 11.9991 12 12Z" fill="#666666"/>
                            </svg> */}
                                                      <img src="/images/Hotel_Location.svg" alt="location-icon" />

                           </div>
                      )}
                       
                        <div className={props.styles.par_div}>
                          <div
                            className={props.styles?.hotel_autocomplete_name}
                          >
                            <span className={props.styles?.hotel_auto_title}>{element.search_text}{" "}</span>
                            <span className={props.styles?.hotel_auto_city}>
                              {" "}
                              {element?.search_type
                                ? search_type_const.search_type_const[element?.search_type]?.text
                                : " "}
                            </span>
                          </div>
                       
                        </div>
                      </div>
                      </>
                    );
                  }): (
                    <div className={props.styles.no_results}  role="alert" aria-live="polite">
                   <div className={props.styles.no_result_icon}>
                      <img src="images/noresult_icon.svg" alt="no-results-icon" />

                   </div>
                    <p className={props.styles.no_results__title} >
                        Oops! no results found.    
                             {/* <br />
                      your search criteria. */}
                    </p>
                    <p className={props.styles.no_results__subtitle} >
                   We didn’t find anything. Try adjusting your search       
                                </p>
                  </div>
                  )}

              </div>
            </div>
          </div>
      </div>
    </div>
    </>:
    <>
     <div  className={props.styles?.select_full_section}
     onClick={() => {
      props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
      props.onChangeHotelName("");
      props.onClickHotelInput();
    }}></div>
    <div  className={props.styles?.hotel_search_wid_inputfield}>
      <label>{props.label}</label>
      <div className={props.styles?.hotel_search_wid_inputfield_main}>
        <div className={props.styles?.hotel_srchCont}>
          <div className={props.styles?.search_auto_flx}>
            <span
              className={props.styles?.hotel_search_left_icon}
              onClick={() => {
                props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
                props.onChangeHotelName("");
                props.onClickHotelInput();
              }}
            >
              {props.leftIcon}
            </span>
            <div className={`${props.styles?.search_widget_img_flex} ${props.styles?.search_widSRp_flx}`}>
              {/* {props.isSrp && (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20">
                  <path
                    fill-rule="evenodd"
                    fill="#01445F"
                    d="M13.74 14.634c-2.441 2.48-3.93 4.946-4.04 5.046-1.397.06-2.544.06-3.312 0-.011-.1-2.229-2.566-4.003-5.046C1.33 12.746 0 10.549 0 8.594 0 4.33 3.463.868 7.729.868s7.729 3.462 7.729 7.726c0 1.955-1.033 4.152-1.718 6.04zM7.729 1.682A6.917 6.917 0 0 0 .813 8.594c0 1.806.985 3.823 2.647 5.567 1.31 2.408 3.464 4.296 3.464 4.296.461.403 1.806.403 1.61 0 0 0 2.155-1.888 3.878-4.296 1.248-1.744 2.233-3.761 2.233-5.567a6.917 6.917 0 0 0-6.916-6.912zm0 10.571c-2.021 0-3.049-1.64-3.049-3.66 0-2.019 1.028-3.659 3.049-3.659 2.02 0 3.661 1.64 3.661 3.659 0 2.02-1.641 3.66-3.661 3.66zm0-6.506c-1.572 0-2.848 1.483-2.848 2.846a2.848 2.848 0 0 0 5.695 0c0-1.363-1.275-2.846-2.847-2.846z"
                  />
                </svg>
              )} */}
              {!props.isSrp && (
                <h1
                  onClick={() => {
                    props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
                    props.onChangeHotelName("");
                    props.onClickHotelInput();
                  }}
                >
                  {" "}
                  {region}{" "}
                </h1>
              )}
              <input
                type="text"
                autoComplete={"off"}
                id="myTextField"
                tabindex="1"
                // autoFocus={!props.isSrp}
                onFocus={props.onInputFocus}
                onKeyDown={props.onKeyDownArrow}
                placeholder={
                  !commonFunction.isValueEmpty(props.placholder)
                    ? props.placholder
                    : ""
                }
                className={props.styles?.search_widget_input_new}
                value={
                  !commonFunction.isValueEmpty(props.value) ? props.value : ""
                }
                onChange={(event) => {
                  props.onChangeHotelName(event.target.value);
                }}
                onClick={() => {
                  props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
                  props.onChangeHotelName("");
                  props.onClickHotelInput();
                }}
              />
            </div>
          </div>

          {!commonFunction.isValueEmpty(props.isError) &&
          props.isError === true ? (
            <div className={props.styles?.hotel_search_error_message}>
              <span>
                {!commonFunction.isValueEmpty(props.errorMessage)
                  ? props.errorMessage
                  : "Enter Destination"}
              </span>
            </div>
          ) : null}
        </div>
        {props.expandAutoCompleteBool === true ? (
          <div className={`${props.styles?.search_section_arrow} ${!props.isMobile ? props.styles?.parent_autocomplete : ""}`}>
            <div
              className={`${props.styles?.hotel_autocomplete_value} ${!props.isMobile ? props.styles?.child_autocomplete : ""}`}
              id="hotelDataArray"
            >
              <p className={props.styles?.popular_destination_text}>Popular Destination</p>
              {!commonFunction.isValueEmpty(props.autoCompleteData) &&
                props.autoCompleteData.length > 0 ?
                props.autoCompleteData.map((element) => {
                  console.log("element icon==>",search_type_const.search_type_const[element?.search_type]?.text);
                  
                  return (
                    <>
                      <div
                        id="hotelData"
                        className={props.styles?.hotel_autocomplete_element}
                        onClick={() => {
                          props.onClickHotelName(element);
                          props.isAutoCompleteExpand(false);
                        }}
                      >
                        {search_type_const.search_type_const[element?.search_type]?.text == "City" ? (
                        <div className={props.styles?.hotel_autocomplete_icons}>
                          <img src="/images/Hotel_Location.svg" alt="location-icon" />

                       </div>
                        ) :search_type_const.search_type_const[element?.search_type]?.text == "Airport" ? (
                          <div className={props.styles?.hotel_autocomplete_icons}>
                           <img src="/images/Hotel_Plane.svg" alt="flightIcon" />

                        </div>
                          ) :search_type_const.search_type_const[element?.search_type]?.text == "Property" ? (
                            <div className={props.styles?.hotel_autocomplete_icons}>
                                    <img src="/images/HotelBed.svg" alt="Bed_icon" />

                          </div>
                            ) :
                          (
                            <div className={props.styles?.hotel_autocomplete_icons}>
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 1.5C7.85953 1.5 4.5 4.52391 4.5 8.25C4.5 14.25 12 22.5 12 22.5C12 22.5 19.5 14.25 19.5 8.25C19.5 4.52391 16.1405 1.5 12 1.5ZM12 12C11.4067 12 10.8266 11.8241 10.3333 11.4944C9.83994 11.1648 9.45542 10.6962 9.22836 10.1481C9.0013 9.59987 8.94189 8.99667 9.05764 8.41473C9.1734 7.83279 9.45912 7.29824 9.87868 6.87868C10.2982 6.45912 10.8328 6.1734 11.4147 6.05764C11.9967 5.94189 12.5999 6.0013 13.1481 6.22836C13.6962 6.45542 14.1648 6.83994 14.4944 7.33329C14.8241 7.82664 15 8.40666 15 9C14.9991 9.79538 14.6828 10.5579 14.1204 11.1204C13.5579 11.6828 12.7954 11.9991 12 12Z" fill="#666666"/>
                            </svg> */}
                               <img src="/images/Hotel_Location.svg" alt="location-icon" />

                           </div>
                      )}
        
                        <div className={props.styles.par_div}>
                          <div
                            className={props.styles?.hotel_autocomplete_name}
                          >
                            <span className={props.styles?.hotel_auto_title}>{element.search_text}{" "}</span>
                            <span className={props.styles?.hotel_auto_city}>
                              {" "}
                              {element?.search_type
                                ? search_type_const.search_type_const[element?.search_type]?.text
                                : " "}
                            </span>
                          </div>

                          <img src="/images/arrow_right_golden.svg" alt="right arrow" />
                       
                        </div>
                      </div>
                    </>
                  );
                }) : (
                  <div className={props.styles.no_results}  role="alert" aria-live="polite">
                  <div className={props.styles.no_result_icon}>
                   {/* <svg xmlns="http://www.w3.org/2000/svg" width="127" height="122" viewBox="0 0 127 122" fill="none">
                      <path d="M65.7343 121.494C99.2839 121.494 126.481 94.2966 126.481 60.747C126.481 27.1974 99.2839 0 65.7343 0C32.1847 0 4.9873 27.1974 4.9873 60.747C4.9873 94.2966 32.1847 121.494 65.7343 121.494Z" fill="#FF6300" fill-opacity="0.1"/>
                      <path d="M110.752 109.796C107.351 108.234 101.569 103.866 105.65 98.9013C110.752 92.6956 113.234 95.0399 112.544 96.9707C111.855 98.9013 106.34 104.832 102.755 99.8669C99.1701 94.9021 102.893 87.4549 104.271 87.0412M1 44.0129C1.68935 46.3115 4.11604 50.4396 8.30772 48.564C13.5471 46.2195 14.7878 42.9096 20.8546 48.564C25.7079 53.0875 30.1386 49.5293 31.747 47.1848M101.376 18.6372C99.9514 15.4653 97.9567 9.39724 101.376 10.5005C105.65 11.8795 98.6184 18.4992 90.07 10.5005" stroke="#FF6300" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"/>
                      <path d="M68.2603 8.50702L69.0501 10.8356L71.1847 11.6972L69.0501 12.5589L68.2603 14.8874L67.4705 12.5589L65.3359 11.6972L67.4705 10.8356L68.2603 8.50702Z" fill="url(#paint0_linear_2706_4492)"/>
                      <path d="M20.806 69.1215L21.7036 71.7412L24.1292 72.7105L21.7036 73.6797L20.806 76.2994L19.9085 73.6797L17.4829 72.7105L19.9085 71.7412L20.806 69.1215Z" fill="url(#paint1_linear_2706_4492)"/>
                      <path d="M41.7267 83.1963L48.1244 89.5937L28.7314 108.987C26.9648 110.753 24.1005 110.753 22.3339 108.987C20.5671 107.22 20.5671 104.356 22.3339 102.589L41.7267 83.1963Z" fill="#FF6300"/>
                      <path d="M40.3458 85.0724L24.1289 101.289" stroke="#CCEFFF" stroke-width="2" stroke-linecap="round"/>
                      <path d="M48.5245 74.3999L56.9214 82.7968L47.7211 91.9971C46.6827 93.0353 44.9996 93.0353 43.9612 91.9971L39.3242 87.3599C38.2858 86.3217 38.2858 84.6384 39.3242 83.6002L48.5245 74.3999Z" fill="#FF6300"/>
                      <path d="M69.8163 92.3982C87.6177 92.3982 102.049 77.9673 102.049 60.1659C102.049 42.3644 87.6177 27.9335 69.8163 27.9335C52.0149 27.9335 37.584 42.3644 37.584 60.1659C37.584 77.9673 52.0149 92.3982 69.8163 92.3982Z" fill="#FF6300"/>
                      <path d="M69.6984 85.1202C83.4398 85.1202 94.5794 73.9806 94.5794 60.2392C94.5794 46.4978 83.4398 35.3582 69.6984 35.3582C55.957 35.3582 44.8174 46.4978 44.8174 60.2392C44.8174 73.9806 55.957 85.1202 69.6984 85.1202Z" fill="url(#paint2_linear_2706_4492)"/>
                      <path d="M84.4546 76.3611C93.3986 67.417 93.3986 52.9156 84.4546 43.9716" stroke="#FF6300" stroke-width="2" stroke-linecap="round"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M67.4626 45.1945C65.9468 45.1945 64.7377 46.4602 64.807 47.9745L65.6708 66.8499C65.7359 68.2695 66.9057 69.3869 68.3267 69.3869H69.5216C70.9426 69.3869 72.1124 68.2695 72.1772 66.8499L73.0413 47.9745C73.1104 46.4602 71.9013 45.1945 70.3854 45.1945H67.4626ZM68.7911 76.8307C70.5532 76.8307 71.9813 75.4026 71.9813 73.6405C71.9813 71.8787 70.5532 70.4503 68.7911 70.4503C67.0293 70.4503 65.6009 71.8787 65.6009 73.6405C65.6009 75.4026 67.0293 76.8307 68.7911 76.8307Z" fill="white"/>
                      <path d="M114.518 60.0824C115.986 60.0824 117.176 58.8921 117.176 57.4239C117.176 55.9556 115.986 54.7654 114.518 54.7654C113.05 54.7654 111.859 55.9556 111.859 57.4239C111.859 58.8921 113.05 60.0824 114.518 60.0824Z" fill="url(#paint3_linear_2706_4492)"/>
                      <defs>
                        <linearGradient id="paint0_linear_2706_4492" x1="71.1847" y1="11.6972" x2="65.3359" y2="11.6972" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E7F8FF"/>
                          <stop offset="1" stop-color="#F2C8AE"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_2706_4492" x1="24.1292" y1="72.7105" x2="17.4829" y2="72.7105" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E7F8FF"/>
                          <stop offset="1" stop-color="#F2C8AE"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear_2706_4492" x1="94.5794" y1="60.2392" x2="44.8174" y2="60.2392" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E7F8FF"/>
                          <stop offset="1" stop-color="#FFCDAD"/>
                        </linearGradient>
                        <linearGradient id="paint3_linear_2706_4492" x1="117.176" y1="57.4239" x2="111.859" y2="57.4239" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#E7F8FF"/>
                          <stop offset="1" stop-color="#F2C8AE"/>
                        </linearGradient>
                      </defs>
                   </svg> */}
                   <img src="images/noresult_icon.svg" alt="no-results-icon" />
                   </div>
                  <p className={props.styles.no_results__title} >
                   Oops! no results found.        
                                {/* <br />
                    your search criteria. */}
                  </p>
                  <p className={props.styles.no_results__subtitle} >
                   We didn’t find anything. Try adjusting your search      
                             </p>
                </div>
                )}
            </div>
          </div>
        ) : null}
        
      </div>
    </div>
    </>
    }
    
    </>
  );
}
